import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination } from '../../../../common/pagination'
import { PAGE_SIZE_OPTIONS } from '../../../constant'
import {
  changePageSizeTable,
  selectDataPageTableSavedPortfolio,
} from '../store/slice/slice'

export const PaginationTableOverview = () => {
  const dispatch = useDispatch()

  const { page, pageSize, totalRecords } = useSelector(
    selectDataPageTableSavedPortfolio,
  )

  const handleSetPage = (value) => {
    dispatch(
      changePageSizeTable({
        page: value,
      }),
    )
  }
  const setPageSize = (value) => {
    dispatch(
      changePageSizeTable({
        pageSize: value,
        page: 1,
      }),
    )
  }
  return (
    <div style={{ paddingTop: 12 }}>
      <Pagination
        page={page}
        pageSize={pageSize}
        total={totalRecords}
        setPage={handleSetPage}
        setPageSize={setPageSize}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
      />
    </div>
  )
}
